export default {
  "navigation": {
    "home": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Start"])},
    "about": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Über die Novatec"])},
    "contact": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kontakt"])},
    "career": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Karriere"])},
    "sites": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Standorte"])},
    "secondarySites": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nebenstandorte"])},
    "headOfficeLeinfeldenEchterdingen": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hauptsitz der Novatec Consulting GmbH"])},
    "headOfficeGranada": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hauptsitz der NOVATEC Software Engineering España S.L."])}
  }
}